import { Text, ToolTip } from '@ui/atoms';
import React from 'react';
import texts from '../en.json';
import { replaceKeysWithValues } from '@helpers/miscelleanous';
import PropTypes from 'prop-types';

const MarketTimings = ({ bgColor = 'bg-gray-50', marketOpenTime = '' }) => {
    const [startTime, endTime] = marketOpenTime?.split('-');
    return (
        <div
            className={`w-full p-2 ${bgColor} rounded-lg flex-col justify-start items-center gap-1 inline-flex border border-gray-100/20 text-basicWhite`}
        >
            <div className="relative inline-flex items-start justify-center gap-1">
                <Text
                    className="text-center p5-medium"
                    content={texts.InvestmentTimings}
                />
                {startTime && endTime ? (
                    <ToolTip
                        content={replaceKeysWithValues(
                            texts.InvestmentTimingToolTipContent,
                            {
                                '{startTime}': startTime,
                                '{endTime}': endTime,
                            }
                        )}
                        position={
                            'absolute z-10 -left-52 md:-left-60 xl:-left-[360px] -top-[76px] md:-top-[68px] xl:top-5 text-gray-900'
                        }
                        interactive={false}
                    />
                ) : null}
            </div>
            <Text
                className="text-center p5-medium"
                content={replaceKeysWithValues(texts.InvestmentTimeSub, {
                    '{marketTime}': marketOpenTime,
                })}
            />
        </div>
    );
};

MarketTimings.propTypes = {
    bgColor: PropTypes.string,
    marketOpenTime: PropTypes.string,
};

export default MarketTimings;
